import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { IMedia, IMediaCollection } from '../types/media.types';

interface MediaInitialState extends BaseDataReducerInitialState<IMedia> {
  isNewMedia: boolean;
  availableCollections: IMediaCollection[] | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducer<IMedia, MediaInitialState>('media-base');

const mediaInitialState: MediaInitialState = {
  ...initialState,
  perPage: 15,
  isNewMedia: false,
  availableCollections: null,
};

export const appMedia = createSlice({
  name: 'media',
  initialState: mediaInitialState,
  reducers: {
    setIsNewMedia: (state, action: PayloadAction<boolean>) => {
      state.isNewMedia = action.payload;
    },

    setAvailableCollections: (state, action: PayloadAction<IMediaCollection[] | null>) => {
      state.availableCollections = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as MediaInitialState, action);
    });
  },
});
export const MediaAC = AC;

export const setMediaCurrentPage = AC.setCurrentPage;
export const onMediaSort = thunks.onSort;
export const onMediaFilter = thunks.onFilter;

export const { setIsNewMedia, setAvailableCollections } = appMedia.actions;
